import templateService from '../../../services/default-template';
import mixin from "../../../mixins/mixin";
import automationService from "../../../services/automation";
import shortCodes from "../../../mixins/shortCodes";

export default {
    data() {
        return {
            templates: [],
            activeTab: 'languages-area',
            currentTemplate: {},
            user: {},
            selectedShortCode: '',
            shortCodeName: '',
            focusedElement: 'body',
            focusedElementType: 'body',
            shortCodes: [],
            langs: ['fr', 'en', 'pt', 'es']
        }
    },
    components: {
      VShortCodeListModal: require('components/short-codes/ShortCodeListModal')
    },
    mixins: [ mixin, shortCodes ],
    async mounted() {
      const vm = this;
        await templateService.get(this);
        await automationService.getCustomShortCodes(vm);
    },
    methods: {
      async updateTemplate(template) {
          await templateService.update(this, template);
          await templateService.get(this);
      },
      changeCurrentTemplate(type, lang) {
        if(this.currentTemplate.name === type) {
          this.currentTemplate = {};
          return;
        }
        this.currentTemplate = this.templates.find(template => template.name === type && template.lang === lang);
      },
      changeTab(tab) {
          this.activeTab = tab;
          this.currentTemplate = {};
      },
      openShortcodeListModal(name) {
          if (this.langs.indexOf(localStorage.getItem('lang')) === -1) {
            this.shortCodeName = 'name_en';
          } else {
            this.shortCodeName = `name_${localStorage.getItem('lang')}`;
          }
          this.openModal(name);
      },
      insertShortcodeToText() {
          let vm = this;
          let elementType = vm.focusedElementType;
          let cursorPosition = vm.focusedElement.selectionStart;
          let text = '';
          if (cursorPosition !== undefined) {
            text = vm.currentTemplate[elementType];
            vm.currentTemplate[elementType] = `${text.substring(0, cursorPosition)}${vm.selectedShortCode}${text.substring(cursorPosition)}`;
          } else {
            toastr.error(this.$t('account.settings.message_templates_section.select_cursor_place'))
          }
          vm.closeModal('#shortcode-list-modal');
      },
      focused(inputRef, el){
          let vm = this;
          vm.focusedElement = vm.$refs[inputRef][0];
          vm.focusedElementType = el;
      },
      getTitleTranslations(name) {
        let result = '';
        switch(name) {
          case "Send contract":
            result = this.$t('account.settings.message_templates_section.send_contract');
            break;
          case "Send invoice":
            result = this.$t('account.settings.message_templates_section.send_invoice');
            break;
          case "Send form":
            result = this.$t('account.settings.message_templates_section.send_form');
            break;
          case "Send payment":
            result = this.$t('account.settings.message_templates_section.send_payment');
            break;
          case "Send schedule payment":
            result = this.$t('account.settings.message_templates_section.send_schedule_payment');
            break;
          case "Send deposit":
            result = this.$t('account.settings.message_templates_section.send_deposit_link_message');
            break;
          case "Send superconcierge invoice":
            result = this.$t('account.settings.message_templates_section.send_superconcierge_invoice');
            break;
        }
        return result;
      },
      changeSelectedShortCode(newSelectedShortCode) {
        this.selectedShortCode = newSelectedShortCode;
      },
      closeShortCodeModal() {
        this.closeModal('#shortcode-list-modal');
      }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/message-templates/index/index.js